import { render } from "./LibyanOrnament.vue?vue&type=template&id=6fae1384&scoped=true"
import script from "./LibyanOrnament.vue?vue&type=script&lang=js"
export * from "./LibyanOrnament.vue?vue&type=script&lang=js"

import "./LibyanOrnament.vue?vue&type=style&index=0&id=6fae1384&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fae1384"]])

export default __exports__